let formModel = {
    locales: [],
    image: '',
    images: [], // For multiple images
    status:0,
    featured:0
}
export default formModel